import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const touService = {
  /**
   * Get TOU acceptance status for current user
   */
  getTOUStatus: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/tou/status`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching TOU status:', error);
      throw error;
    }
  },

  /**
   * Accept TOU and Privacy Policy
   */
  acceptTOU: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_URL}/api/tou/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error accepting TOU:', error);
      throw error;
    }
  },

  /**
   * Get Terms of Use document
   */
  getTOUDocument: async () => {
    try {
      const response = await axios.get(`${API_URL}/api/tou/tou`);
      return response.data;
    } catch (error) {
      console.error('Error fetching TOU document:', error);
      throw error;
    }
  },

  /**
   * Get Privacy Policy document
   */
  getPrivacyDocument: async () => {
    try {
      const response = await axios.get(`${API_URL}/api/tou/privacy`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Privacy document:', error);
      throw error;
    }
  }
};

export default touService;
